module.exports = __webpack_public_path__ + "img/stock1.55402fbc.png";